<template>
  <span
    class="ml-1"
    style="white-space: nowrap"
  >

    <template v-if="singleStar">
      <i
        v-if="rating>0"
        class="fa fa-star text-warning"
      />
      <i
        v-else
        class="fa fa-star-o"
      />
    </template>
    <template
      v-for="n in 5"
      v-else
    >
      <i
        v-if="rating >= n"
        class="fa fa-star text-warning"
      />
      <i
        v-else
        class="fa fa-star-o"
      />
    </template>
    {{ $t('starRatingView.ss', {toFixed: rating.toFixed(1), expr: count || ' -'}) }}
  </span>
</template>
<script>
export default {
  name: 'StarRatingView',
  props: {
    count: {
      type: Number,
      default: 0
    },
    total: {
      type: Number,
      default: 0
    },
    singleStar: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    rating() {
      if ( this.count && this.totoal && this.count > 0) {
        return (this.total / this.count).toFixed(1)
      } else {
        return 0;
      }
    }
  }
}
</script>
<style>
</style>
